import React, { useEffect, useState } from 'react';
import videojog from './Assets/Courtpaddle-small.mp4';

const LandingPage = () => {
  const [loaded, setLoaded] = useState(false);
  

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 300);
    return () => clearTimeout(timer);
    
  }, []);


  return (
    <div className="landing-container">
      <div className={`overlay ${loaded ? 'overlay-visible' : ''}`} />

      <video
        src={videojog} autoPlay loop muted playsInline revertrac
        className={`background-video ${loaded ? 'video-visible' : ''}`}
      />

      <div className={`content ${loaded ? 'content-visible' : ''}`}>
        <h1 className="fade-up">We’ll Be Back Soon!</h1>
        <p className="fade-up">
          We’re currently making some improvements behind the scenes to boost your experience.
          Thanks for your patience — we’ll be back in the game shortly!


        </p>
      </div>

      <div className={`company-info fade-up`}>
        <h2>PT. Lingkaran Multi Kreasi</h2>
      </div>

      <style>{`
        .landing-container {
          position: relative;
          height: 100vh;
          background: #000;
          overflow: hidden;
          font-family: 'Poppins', sans-serif;
          color: #fff;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .background-video {
          position: absolute;
          top: 50%;
          left: 50%;
          min-width: 100%;
          min-height: 100%;
          transform: translate(-50%, -50%);
          object-fit: cover;
          opacity: 0;
          transition: opacity 2s ease;
          z-index: 0;
          filter: brightness(0.8) saturate(1.2);
          animation: zoomPan 20s ease-in-out infinite;
        }

        .video-visible {
          opacity: 0.6;
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: radial-gradient(circle, rgba(0,0,0,0.3), rgba(0,0,0,0.75));
          opacity: 0;
          transition: opacity 2s ease;
          z-index: 1;
          animation: pulseOverlay 6s infinite;
        }

        .overlay-visible {
          opacity: 0.7;
        }

        .content {
          position: relative;
          z-index: 2;
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          opacity: 0;
          transition: opacity 2s ease 0.8s;
        }

        .content-visible {
          opacity: 1;
        }

        h1 {
          font-size: 4rem;
          margin-bottom: 1rem;
          text-shadow: 0 0 15px rgba(0, 0, 0, 0.85);
          animation: fadeUp 1s ease forwards 1.2s;
          opacity: 0;
          line-height: 1.1;
        }

        p {
          font-size: 1.2rem;
          max-width: 900px;
          line-height: 1.6;
          letter-spacing: 1.2px;
          animation: fadeUp 1s ease forwards 1.5s;
          opacity: 0;
          margin: 0 auto;
          padding: 0 10px;
        }

        .company-info {
          position: fixed;
          top: 1.5rem;
          left: 1.5rem;

          padding: 1rem 1.25rem;
          max-width: 300px;
          font-size: 0.9rem;
          color: #f0f0f0;
          animation: fadeUp 1s ease forwards 1.8s;
          opacity: 0;
          text-align: left;
          z-index: 5;
        
        }

        .company-info h2 {
          margin-bottom: 0.5rem;
          font-size: 1.3rem;
          font-weight: 700;
          color: #ffffff;
        }

        .company-info p {
          margin: 0.1rem 0;
          color: #ddd;
        }

        @keyframes fadeUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes zoomPan {
          0%, 100% {
            transform: translate(-50%, -50%) scale(1);
          }
          50% {
            transform: translate(-50%, -52%) scale(1.05);
          }
        }

        @keyframes pulseOverlay {
          0%, 100% {
            opacity: 0.7;
          }
          50% {
            opacity: 0.9;
          }
        }

        /* Responsive styles */
        @media (max-width: 900px) {
          h1 {
            font-size: 3rem;
          }
          p {
            font-size: 1.1rem;
            max-width: 90%;
            letter-spacing: 1px;
          }
          .company-info {
            max-width: 280px;
            font-size: 0.85rem;
            padding: 0.9rem 1rem;
          }
        }

        @media (max-width: 600px) {
          h1 {
            font-size: 2.2rem;
            margin-bottom: 0.8rem;
          }
          p {
            font-size: 1rem;
            max-width: 95%;
            letter-spacing: 0.8px;
            padding: 0 8px;
          }
          .company-info {
            top: auto;
            right: auto;
            top: 1.5rem;
            right: 10%;
            transform: translateX(-50%);
            max-width: 90%;
            font-size: 0.85rem;
            padding: 0.7rem 1rem;
            text-align: center;
            animation-delay: 2s;
          }
        }
      `}</style>
    </div>
  );
};

export default LandingPage;
